import moment from "moment";
import {
    IS_TICKET_EXTERNAL_ACCESS_BLOCKED,
    TICKET_ONBOARDING_CATEGORY_TYPES
} from "constants/ticket";
import {managerCompanyOptions} from "constants/constants";

// Dış erişim kapalıyken kurye ve işletme taleplerinin notları sahibine gösterilemez; ilgili switch'ler kilitlenir
export const isOwnerNoteVisibilityLocked = ticket =>
    IS_TICKET_EXTERNAL_ACCESS_BLOCKED &&
    ["courier", "company"].includes(ticket?.ticketType?.category);

export const formatDateTime = date => (date ? moment(date).format("DD.MM.YYYY HH:mm") : "-");

export const formatDate = date => (date ? moment(date).format("DD.MM.YYYY") : "-");

export const formatFullDateTime = date => (date ? moment(date).format("DD.MM.YYYY HH:mm:ss") : "-");

export const formatTime = date => (date ? moment(date).format("HH:mm:ss") : "");

// Departman listeleri Türkçe alfabetik sıralanır
export const sortByName = options =>
    [...options].sort((a, b) => (a.name || "").localeCompare(b.name || "", "tr"));

export const getManagerCompanyLabel = managerCompany =>
    managerCompanyOptions.find(option => option.value === managerCompany)?.name || "-";

// Geçen süre: oluşturmadan kapanış/iptale kadar, talep açıksa şimdiye kadar
export const getElapsedLabel = (ticket, t) => {
    const end = ticket.closedAt || ticket.cancelledAt || new Date();
    const minutes = Math.max(moment(end).diff(moment(ticket.createdAt), "minutes"), 0);
    if (minutes < 60) return t("elapsed.minutes", {ns: "tickets", count: minutes});
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return t("elapsed.hours", {ns: "tickets", count: hours});
    const days = Math.floor(hours / 24);
    if (days < 30) return t("elapsed.days", {ns: "tickets", count: days});
    const months = Math.floor(days / 30);
    if (months < 12) return t("elapsed.months", {ns: "tickets", count: months});
    return t("elapsed.years", {ns: "tickets", count: Math.floor(months / 12)});
};

export const getAssigneeLabel = (ticket, roleLabels) => {
    if (ticket.assignedUser?.fullName) {
        return ticket.assignedUser.fullName;
    }
    const roles = [].concat(ticket.assignedTo?.role || []);
    return roles.map(role => roleLabels[role] || role).join(", ") || "-";
};

// "Departman - Ad Soyad"; departman karşılığı olmayan roller (ör. admin) yalnızca ad ile gösterilir
export const getActorLabel = (actor, roleLabels) => {
    if (!actor?.name) return "-";
    return roleLabels[actor.role] ? `${roleLabels[actor.role]} - ${actor.name}` : actor.name;
};

export const getOwnerRoute = ticket => {
    const category = ticket.ticketType?.category;
    if (category === "courier") return `/couriers/${ticket.owner?._id}`;
    if (category === "company") return `/companies/sub-company/${ticket.owner?._id}`;
    const applicationType = TICKET_ONBOARDING_CATEGORY_TYPES[category];
    if (applicationType) return `/applications/${applicationType}/${ticket.owner?._id}`;
    return null;
};
